// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
------------------------------------------------------------
|  main app layout
------------------------------------------------------------
*/

#chartContainer{
  width:800px;
  margin:auto;
}

h2 {
  font-size: 1.65rem;
  padding-bottom: 20px;
}

.title-bar h2 {
  padding-bottom: 0 !important;
}

h3 {
  font-size: 1.1rem;
}

caption {
  caption-side: top;
}

table thead th {
  white-space: normal !important;
}

.smallPadding th, .smallPadding td {
  padding: 5px !important;
  line-height: 1.0 !important;
}


a {
  cursor: pointer !important;
}

.pointer {
  cursor: pointer !important;
}

.verticalList {
  height: 200px;
  margin-left: 0;
  overflow-y: scroll;
  border-top: #cccccc solid 3px;
  border-bottom: #cccccc solid 3px;
  border-radius: 5px;
  background: #fff;
}

.verticalList nav {
  padding-left: 10px !important;
  margin-bottom: 5px !important;
}

.verticalList a {
  color: #007bff !important;
  font-weight: bold !important;
}

.verticalList label {
  padding-bottom: 5px !important;
  padding-top: 5px !important;
  display: block !important;
  clear: left !important;
}

.verticalList input[type=checkbox] {
  float: left !important;
  margin-top: 4px !important;
  margin-bottom: 10px !important;
}

.selectedListItem, .selectedListItem > a {
  background-color: #122366 !important;
  color: #fff !important;
}

fieldset {
  padding-bottom: 0px !important;
  margin-bottom: 0;
  margin-top: 0;
  padding-top: 30px;
  background: none;
}

  fieldset legend {
    color: #000 !important;
    background: none !important;
    font-weight: bold !important;
    font-size: 0.9rem !important;
    padding: 0 0.625rem !important;
  }

.inlineTable {
  margin: auto;
  padding: 0 !important;
  background-color: transparent !important;
  border: 0 !important;
}

  .inlineTable tr, .inlineTable td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-right: 5px;
    background-color: transparent !important;
    border: 0 !important;
    vertical-align: middle;
  }

  .inlineTable hr {
    margin-top: 2px;
    margin-bottom: 2px;
  }

fieldset legend {
  background: #122366;
  color: #fff;
  font-size: 20px;
  margin-bottom: 1px;
  padding-bottom: 3px;
}

.appContainer {
  padding-bottom: 0px !important;
  margin-bottom: 0;
  margin-top: 0;
  background: none;
}

DIV.appContainer h1 {
  background: #122366;
  color: #fff;
  font-size: 20px;
  margin-bottom: 1px;
  padding-bottom: 3px;
  padding-left: 5px;
}

.innerPageDivs {
  background-color: #efefef;
  padding: 1%;
  min-height: 500px;
}

.pseudo-accordion {
  display: block;
  position: relative;
  margin-top: 2px;
  margin-bottom: 0;
  min-height: 0;
  /*background: #fff;*/
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid #cccccc;
  width: 100%;
  text-align: left;
}

  .pseudo-accordion > h2 {
    color: #122366;
    font-size: 18px;
    margin: 0.75em;
  }

  .pseudo-accordion > h3 {
    color: #122366;
    font-size: 14px;
    margin: 0.75em;
    margin: 0.75em;
    margin-top: -15px;
    margin-left: 1em;
  }

  .pseudo-accordion > div {
    background-color: #efefef;
    padding: 0.75em;
  }

  .pseudo-accordion a {
    text-decoration: underline;
    font-weight: bold;
  }
/*--------------------------------------------------------*/



/*
------------------------------------------------------------
|  Text styles
------------------------------------------------------------
*/

.errorMessageText {
  color: red;
  font-size: 25px;
}

/*--------------------------------------------------------*/


/*
------------------------------------------------------------
|  Data warehouse styles
------------------------------------------------------------
*/
.icon {
  width: auto !important;
  margin-bottom: 0 !important;
  position: relative;
  top: -4px;
}

.report {
  font-weight: bold;
  display: block;
  padding-bottom: 1em;
  cursor: pointer;
}

/* iOS Safari does not fire tap/click events on <a> elements that lack an
   href attribute unless they are styled with cursor: pointer. The accordion
   triggers in StandardReports/StartPage use <a onClick> without href, so
   ensure they are recognized as interactive on iOS. */
.card-header a {
  cursor: pointer;
}

/* CustomReports uses <a href="" onClick> with font-weight-bold for Select all/Clear all
   links. Empty href doesn't satisfy iOS tap heuristic, so ensure these are recognized
   as interactive. */
a.font-weight-bold {
  cursor: pointer;
}

.dataButton a, .dataButton, a.dataButton:visited {
  filter: none !important;
  background: #122366;
  color: #fff;
  margin-top: 5px;
  text-shadow: none;
}

  .dataButton a, .dataButton:hover:not([disabled]) {
    color: #122366;
    background: #eee;
  }

  .dataButton a, .dataButton:disabled {
    background: #dddddd;
  }

a.dataButton {
  padding: 8px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
}

.form-control {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

textarea.form-control {
  height: 125px;
}

.fortypct {
  width: 40% !important;
  display: inline-block;
}
/*--------------------------------------------------------*/


/*
------------------------------------------------------------
|  Data table styles that should be replaced with existing styles
------------------------------------------------------------
*/
.header {
  background-color: #122366;
  color: #fff;
  font-weight: bold;
  border: 1px solid #91a4f1;
}

.dwGridRow {
  background-color: #fff;
  color: #000;
  border: 1px solid #91a4f1;
}

.dwGridRowGray {
  background-color: lightgray;
  color: #000;
  border: 1px solid #91a4f1;
  font-weight: bold;
}

.bold {
  color: #000;
  font-weight: bold;
}
/*--------------------------------------------------------*/


/*
------------------------------------------------------------
|  CSS Grid styles
------------------------------------------------------------
*/
.cell2_1 {
  grid-column: 1 !important;
  grid-row: 2 !important;
}

.cell2_2 {
  grid-column: 2 !important;
  grid-row: 2 !important;
}

.vendorsReportedGrid {
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  grid-template-rows: auto auto auto auto auto;
  width: 100%;
}

.vendorsReportedGrid2col {
  display: grid;
  grid-template-columns: 35% 60%;
  grid-template-rows: auto auto;
  width: 100%;
}

.vendorsReportedGrid3col {
  display: grid;
  grid-template-columns: 35% 40% 20%;
  grid-template-rows: auto auto;
  width: 100%;
}

.vendorsReportedGrid6Col {
  display: grid;
  grid-template-columns: 16% 16% 16% 16% 16% 16%;
  grid-template-rows: auto auto auto auto auto;
  width: 100%;
}

.vendorsReportedGrid7Col {
  display: grid;
  grid-template-columns: 14% 14% 14% 14% 14% 14%;
  grid-template-rows: auto auto auto auto auto;
  width: 100%;
}

.vendorsReportedGrid8Col {
  display: grid;
  grid-template-columns: 12% 12% 12% 12% 12% 12%;
  grid-template-rows: auto auto auto auto auto;
  width: 100%;
}

  .vendorsReportedGrid2col DIV, .vendorsReportedGrid DIV, .vendorsReportedGrid6Col DIV, .vendorsReportedGrid7Col DIV, .vendorsReportedGrid8Col DIV {
    padding: 10px;
    font-family: Arial;
  }

.newRow {
  grid-column-start: 1;
}

.col1 {
  grid-column: 1 !important;
}

.col2 {
  grid-column: 2 !important;
}

.col3 {
  grid-column: 3 !important;
}

.col4 {
  grid-column: 4 !important;
}

.col5 {
  grid-column: 5 !important;
}

.row2 {
  grid-row: 2 !important;
}

.row3 {
  grid-row: 3 !important;
}

.row4 {
  grid-row: 4 !important;
}

.row5 {
  grid-row: 5 !important;
}

.row6 {
  grid-row: 6 !important;
}
/*--------------------------------------------------------*/


.rotated {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
}

.center {
  text-align: center;
}

/*
------------------------------------------------------------
|  table styles
------------------------------------------------------------
*/
.grid-container {
  display: grid;
  grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;
  grid-template-rows: auto auto auto auto auto auto;
}

.grid-container-Fuel {
  display: grid;
  grid-template-columns: 3% 12% 12% 12% 12% 12% 12% 12%;
  grid-template-rows: auto auto auto auto auto auto auto auto auto;
}

.grid-container-Fuel2 {
  display: grid;
  grid-template-columns: 3% 12% 8% 8% 8% 8% 8% 8% 8% 8% 8% 8%;
  grid-template-rows: auto auto auto auto auto auto auto auto auto;
}

  .grid-container-Fuel div, .grid-container-Fuel2 div {
    padding: 5px;
    font-family: Arial;
    /*font-size: 0.9rem !important;*/
  }


.grid-item {
  padding: 10px;
  text-align: center;
  font-family: Arial;
  font-size: 14px;
}

.rowboundary1_3 {
  grid-row-start: 1 !important;
  grid-row-end: 3 !important;
}

.rowboundary1_2 {
  grid-row-start: 1 !important;
  grid-row-end: 2 !important;
}

.rowboundary2_3 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
}

.rowboundary3_4 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
}

.rowboundary3_6 {
  grid-row-start: 3 !important;
  grid-row-end: 6 !important;
}

.rowboundary4_5 {
  grid-row-start: 4 !important;
  grid-row-end: 5 !important;
}

.rowboundary4_7 {
  grid-row-start: 4 !important;
  grid-row-end: 7 !important;
}

.rowboundary5_6 {
  grid-row-start: 5 !important;
  grid-row-end: 6 !important;
}

.rowboundary6_7 {
  grid-row-start: 6 !important;
  grid-row-end: 7 !important;
}

.colboundary3_8 {
  grid-column-start: 3 !important;
  grid-column-end: 8 !important;
}

.colboundary3_13 {
  grid-column-start: 3 !important;
  grid-column-end: 13 !important;
}

.colboundary1_2 {
  grid-column-start: 1 !important;
  grid-column-end: 2 !important;
}

.colboundary1_5 {
  grid-column-start: 1 !important;
  grid-column-end: 5 !important;
}

.colboundary2_3 {
  grid-column-start: 2 !important;
  grid-column-end: 3 !important;
}

.colboundary3_4 {
  grid-column-start: 3 !important;
  grid-column-end: 4 !important;
}

.colboundary4_5 {
  grid-column-start: 4 !important;
  grid-column-end: 5 !important;
}


.colboundary3_5 {
  grid-column-start: 3 !important;
  grid-column-end: 5 !important;
}

.colboundary3_7 {
  grid-column-start: 3 !important;
  grid-column-end: 7 !important;
}

.colboundary3_9 {
  grid-column-start: 3 !important;
  grid-column-end: 9 !important;
}

.colboundary5_7 {
  grid-column-start: 5 !important;
  grid-column-end: 7 !important;
}

.colboundary5_6 {
  grid-column-start: 5 !important;
  grid-column-end: 6 !important;
}

.colboundary6_7 {
  grid-column-start: 6 !important;
  grid-column-end: 7 !important;
}

.colboundary7_9 {
  grid-column-start: 7 !important;
  grid-column-end: 9 !important;
}

.colboundary7_8 {
  grid-column-start: 7 !important;
  grid-column-end: 8 !important;
}

.colboundary8_9 {
  grid-column-start: 8 !important;
  grid-column-end: 9 !important;
}

.colboundary9_10 {
  grid-column-start: 9 !important;
  grid-column-end: 10 !important;
}

.colboundary9_11 {
  grid-column-start: 9 !important;
  grid-column-end: 11 !important;
}

.colboundary10_11 {
  grid-column-start: 10 !important;
  grid-column-end: 11 !important;
}

.colboundary11_12 {
  grid-column-start: 11 !important;
  grid-column-end: 12 !important;
}

.colboundary11_13 {
  grid-column-start: 11 !important;
  grid-column-end: 13 !important;
}

.colboundary12_13 {
  grid-column-start: 12 !important;
  grid-column-end: 13 !important;
}

.item1 {
  grid-row-start: 1 !important;
  grid-row-end: 3 !important;
}

.item2 {
  grid-column-start: 2 !important;
  grid-column-end: 4 !important;
}

.item3 {
  grid-column-start: 4 !important;
  grid-column-end: 6 !important;
}

.item4 {
  grid-column-start: 6 !important;
  grid-column-end: 8 !important;
}

.item5 {
  grid-column-start: 8 !important;
  grid-column-end: 10 !important;
}

.item6 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 2 !important;
  grid-column-end: 3 !important;
}

.item7 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 3 !important;
  grid-column-end: 4 !important;
}

.item8 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 4 !important;
  grid-column-end: 5 !important;
}

.item9 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 5 !important;
  grid-column-end: 6 !important;
}

.item10 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 6 !important;
  grid-column-end: 7 !important;
}

.item11 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 7 !important;
  grid-column-end: 8 !important;
}

.item12 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 8 !important;
  grid-column-end: 9 !important;
}

.item13 {
  grid-row-start: 2 !important;
  grid-row-end: 3 !important;
  grid-column-start: 9 !important;
  grid-column-end: 10 !important;
}

.item14 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 1 !important;
  grid-column-end: 2 !important;
}

.item15 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 2 !important;
  grid-column-end: 3 !important;
}

.item16 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 3 !important;
  grid-column-end: 4 !important;
}

.item17 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 4 !important;
  grid-column-end: 5 !important;
}

.item18 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 5 !important;
  grid-column-end: 6 !important;
}

.item19 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 6 !important;
  grid-column-end: 7 !important;
}

.item20 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 7 !important;
  grid-column-end: 8 !important;
}

.item21 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 8 !important;
  grid-column-end: 9 !important;
}

.item22 {
  grid-row-start: 3 !important;
  grid-row-end: 4 !important;
  grid-column-start: 9 !important;
  grid-column-end: 10 !important;
}

.item23 {
  grid-column-start: 2 !important;
  grid-column-end: 9 !important;
  margin-left: 8.5%;
  margin-right: 8.5%;
  grid-row-start: 4 !important;
  grid-row-end: 5 !important;
  /*height:400px;*/
}

.lev2-grid-container {
  display: grid;
  grid-template-columns: 32% 36% 32%;
  grid-template-rows: auto;
}

.lev3-grid-container {
  display: grid;
  grid-template-columns: 10% 80% 10%;
  grid-template-rows: auto;
}

.lev4-grid-container {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
}

.orange-block {
  background-color: orange;
  margin-top: 20px;
}

.orange-block-header {
  padding: 5px;
  /*height: 100px;*/
}

.left-arrow {
  border-left: 2px solid #91a4f1;
  border-bottom: 2px solid #91a4f1;
  height: 75px;
}

.right-arrow {
  border-right: 2px solid orange;
  border-bottom: 2px solid orange;
  height: 75px;
}

.white-border {
  border: 1px solid #fff;
  text-align: center;
}

.blue-background {
  background-color: #bdd6ee;
}

.orange-background {
  background-color: #f4b083;
}

.yellow-background {
  background-color: #ffe599;
}

.gray-background {
  background-color: gray !important;
}

.green-background {
  background-color: #c6efce;
  color: #006100;
}

.red-background {
  background-color: #ffc7ce;
  color: #9c0006;
}

.greentext {
  color: darkgreen;
  font-weight: bold;
}

.redtext {
  color: darkred;
  font-weight: bold;
}

.marginTop15 {
  margin-top: 15px;
}

ul.legendList li.blueBullet::before {
  color: #bdd6ee;
}

ul.legendList li.orangeBullet::before {
  color: #f4b083;
}

ul.legendList li.yellowBullet::before {
  color: #ffe599;
}

ul.legendList li.greenBullet::before {
  color: #c6efce;
}

ul.legendList li.redBullet::before {
  color: #ffc7ce;
}

div.legendDiv {
  float: right;
  width: 60%;
}

ul.legendList {
  font-size: 0.75em;
  list-style: none;
  margin-top: 10px;
}

  ul.legendList li {
    margin-top: -5px;
  }

    ul.legendList li::before {
      content: "\\25C6"; /* Add content: \\2022 is the CSS Code/unicode for a bullet */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
      font-size: 1.5em;
    }

.lowercaseList {
  list-style-type: lower-alpha;
}

input:invalid {
  border: 2px dashed red;
  background-color: pink;
}

input.form-control {
  display: inline-block;
  width: 80%;
}

.requiredDash {
  color: red;
  padding-right: 5px;
}

ul.requiredDashList {
  font-size: 0.75em;
  list-style: none;
  margin-top: 10px;
  margin-bottom: -15px;
}

  ul.requiredDashList li {
    margin-top: -5px;
  }

    ul.requiredDashList li::before {
      color: red;
      content: "\\002A"; /* Add content: \\002A is the CSS Code/unicode for asterisk */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
      font-size: 1.5em;
    }



.react-tabs__tab-list {
  margin-bottom: 0 !important;
}

.react-tabs__tab-panel--selected {
  background-color: #fff;
  padding: 10px;
  border: 1px solid #aaa;
  border-top: none;
}

.react-tabs__tab {
  border-color: #aaa !important;
  color: black !important;
  border-radius: 5px 5px 0 0 !important;
}



.pseudo-accordion {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.takeaways {
  border: #000 solid 3px;
  padding: 1.5%;
}

/*------------------------------------------------------------------------
    Guided search breadcrums
--------------------------------------------------------------------------
*/
.steps {
  /*padding-left: 1%;*/
  padding-left: 0px;
  margin: 14px 0 24px 0;
  height: 32px;
  white-space: nowrap;
  font-weight: bold;
}

  .steps .active {
    background-image: url("/data_warehouse/images/step_a.png");
  }

  .steps .step span {
    display: inline-block;
    padding-left: 5px;
    padding-right: 7px;
    color: #324f6e;
    background-color: #ffe0a6;
    font-size: 121%;
    font-style: italic;
  }

  .steps .step {
    display: inline-block;
    background: url("/data_warehouse/images/step_a.png") no-repeat top right;
    padding: 3px 17px 0 3px;
    margin-right: 5px;
    height: 34px;
    color: #fff;
    shadow: 5px 5px 4px #888888;
    float: left;
  }

  .steps .completed {
    background-image: url("/data_warehouse/images/step_c.png");
    padding: 3px 17px 0 3px;
    color: rgb(58, 110, 162);
    color: #f1f1f1;
    cursor: pointer;
  }

  .steps .gray, .steps .laststepgray {
    background-image: url("/data_warehouse/images/step_g.png");
    color: #f1f1f1;
    cursor: default;
  }

  .steps .laststepgray {
    background-image: url("/data_warehouse/images/step_g_last.png");
  }


/*------------------------------------------------------------------
| Benefit matrix styles
--------------------------------------------------------------------*/
.benefitMatrix p, .benefitMatrix b, .benefitMatrix span, .benefitMatrix li {
  font-size: x-large;
}

.benefitMatrix button, .benefitMatrix th, .benefitMatrix td, .benefitMatrix .grid-container-Fuel, .benefitMatrix .grid-container-Fuel2, .benefitMatrix .vendorsReportedGrid, .benefitMatrix .vendorsReportedGrid2col, .benefitMatrix .vendorsReportedGrid3col, .benefitMatrix .vendorsReportedGrid6Col, .benefitMatrix .vendorsReportedGrid7Col, .benefitMatrix .vendorsReportedGrid8Col, .benefitMatrix .vendorsReportedGrid span, .benefitMatrix .vendorsReportedGrid2col span, .benefitMatrix .vendorsReportedGrid3col span, .benefitMatrix .vendorsReportedGrid6Col span, .benefitMatrix .vendorsReportedGrid7Col span, .benefitMatrix .vendorsReportedGrid8Col span, .container .col-sm-2 {
  font-size: 20px !important;
}
/*------------------------------------------------------------------*/
@media print {
  .page-footer, .sidebar-content, .noPrint {
    display: none;
  }
}
/*--------------------------------------------------------*/
/* Fix for Material-UI slider labels with webpack 5 */
.MuiSlider-marked .MuiSlider-markLabel {
  transform: translateX(-65%) rotate(-45deg) !important;
  transform-origin: center top !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;EAEE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;EAChC;;AAEF;EACE,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;AACtB;;EAEE;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,wCAAwC;IACxC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;AAEF;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;EAEE;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF,2DAA2D;;;;AAI3D;;;;CAIC;;AAED;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,2DAA2D;;;AAG3D;;;;CAIC;AACD;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;sDAGsD;AACtD;EACE,eAAe;AACjB;;AAEA;;oBAEoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;EAEE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;EACE,YAAY;EACZ,qBAAqB;EAErB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAElB,+CAA+C;EAG/C,sEAAsE;AACxE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA,2DAA2D;;;AAG3D;;;;CAIC;AACD;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA,2DAA2D;;;AAG3D;;;;CAIC;AACD;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,4CAA4C;EAC5C,WAAW;AACb;;EAEE;IACE,aAAa;IACb,kBAAkB;EACpB;;AAEF;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA,2DAA2D;;;AAG3D;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;CAIC;AACD;EACE,aAAa;EACb,8DAA8D;EAC9D,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gEAAgE;AAClE;;EAEE;IACE,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;;AAGF;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;;AAGA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;EAEE;IACE,gBAAgB;EAClB;;IAEE;MACE,gBAAgB,EAAE,4DAA4D;MAC9E,iBAAiB,EAAE,8BAA8B;MACjD,qBAAqB,EAAE,wDAAwD;MAC/E,UAAU,EAAE,4CAA4C;MACxD,iBAAiB,EAAE,4CAA4C;MAC/D,gBAAgB;IAClB;;AAEJ;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;EAEE;IACE,gBAAgB;EAClB;;IAEE;MACE,UAAU;MACV,gBAAgB,EAAE,4DAA4D;MAC9E,iBAAiB,EAAE,8BAA8B;MACjD,qBAAqB,EAAE,wDAAwD;MAC/E,UAAU,EAAE,4CAA4C;MACxD,iBAAiB,EAAE,4CAA4C;MAC/D,gBAAgB;IAClB;;;;AAIJ;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,qCAAqC;AACvC;;;;AAIA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;CAGC;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;EAEE;IACE,0DAA0D;EAC5D;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,wEAAwE;IACxE,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,0DAA0D;IAC1D,uBAAuB;IACvB,wBAAwB;IACxB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0DAA0D;IAC1D,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,+DAA+D;EACjE;;;AAGF;;qEAEqE;AACrE;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;AACA,qEAAqE;AACrE;EACE;IACE,aAAa;EACf;AACF;AACA,2DAA2D;AAC3D,qDAAqD;AACrD;EACE,qDAAqD;EACrD,uCAAuC;AACzC","sourcesContent":["/*\n------------------------------------------------------------\n|  main app layout\n------------------------------------------------------------\n*/\n\n#chartContainer{\n  width:800px;\n  margin:auto;\n}\n\nh2 {\n  font-size: 1.65rem;\n  padding-bottom: 20px;\n}\n\n.title-bar h2 {\n  padding-bottom: 0 !important;\n}\n\nh3 {\n  font-size: 1.1rem;\n}\n\ncaption {\n  caption-side: top;\n}\n\ntable thead th {\n  white-space: normal !important;\n}\n\n.smallPadding th, .smallPadding td {\n  padding: 5px !important;\n  line-height: 1.0 !important;\n}\n\n\na {\n  cursor: pointer !important;\n}\n\n.pointer {\n  cursor: pointer !important;\n}\n\n.verticalList {\n  height: 200px;\n  margin-left: 0;\n  overflow-y: scroll;\n  border-top: #cccccc solid 3px;\n  border-bottom: #cccccc solid 3px;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.verticalList nav {\n  padding-left: 10px !important;\n  margin-bottom: 5px !important;\n}\n\n.verticalList a {\n  color: #007bff !important;\n  font-weight: bold !important;\n}\n\n.verticalList label {\n  padding-bottom: 5px !important;\n  padding-top: 5px !important;\n  display: block !important;\n  clear: left !important;\n}\n\n.verticalList input[type=checkbox] {\n  float: left !important;\n  margin-top: 4px !important;\n  margin-bottom: 10px !important;\n}\n\n.selectedListItem, .selectedListItem > a {\n  background-color: #122366 !important;\n  color: #fff !important;\n}\n\nfieldset {\n  padding-bottom: 0px !important;\n  margin-bottom: 0;\n  margin-top: 0;\n  padding-top: 30px;\n  background: none;\n}\n\n  fieldset legend {\n    color: #000 !important;\n    background: none !important;\n    font-weight: bold !important;\n    font-size: 0.9rem !important;\n    padding: 0 0.625rem !important;\n  }\n\n.inlineTable {\n  margin: auto;\n  padding: 0 !important;\n  background-color: transparent !important;\n  border: 0 !important;\n}\n\n  .inlineTable tr, .inlineTable td {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    padding-right: 5px;\n    background-color: transparent !important;\n    border: 0 !important;\n    vertical-align: middle;\n  }\n\n  .inlineTable hr {\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\nfieldset legend {\n  background: #122366;\n  color: #fff;\n  font-size: 20px;\n  margin-bottom: 1px;\n  padding-bottom: 3px;\n}\n\n.appContainer {\n  padding-bottom: 0px !important;\n  margin-bottom: 0;\n  margin-top: 0;\n  background: none;\n}\n\nDIV.appContainer h1 {\n  background: #122366;\n  color: #fff;\n  font-size: 20px;\n  margin-bottom: 1px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n}\n\n.innerPageDivs {\n  background-color: #efefef;\n  padding: 1%;\n  min-height: 500px;\n}\n\n.pseudo-accordion {\n  display: block;\n  position: relative;\n  margin-top: 2px;\n  margin-bottom: 0;\n  min-height: 0;\n  /*background: #fff;*/\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border: 1px solid #cccccc;\n  width: 100%;\n  text-align: left;\n}\n\n  .pseudo-accordion > h2 {\n    color: #122366;\n    font-size: 18px;\n    margin: 0.75em;\n  }\n\n  .pseudo-accordion > h3 {\n    color: #122366;\n    font-size: 14px;\n    margin: 0.75em;\n    margin: 0.75em;\n    margin-top: -15px;\n    margin-left: 1em;\n  }\n\n  .pseudo-accordion > div {\n    background-color: #efefef;\n    padding: 0.75em;\n  }\n\n  .pseudo-accordion a {\n    text-decoration: underline;\n    font-weight: bold;\n  }\n/*--------------------------------------------------------*/\n\n\n\n/*\n------------------------------------------------------------\n|  Text styles\n------------------------------------------------------------\n*/\n\n.errorMessageText {\n  color: red;\n  font-size: 25px;\n}\n\n/*--------------------------------------------------------*/\n\n\n/*\n------------------------------------------------------------\n|  Data warehouse styles\n------------------------------------------------------------\n*/\n.icon {\n  width: auto !important;\n  margin-bottom: 0 !important;\n  position: relative;\n  top: -4px;\n}\n\n.report {\n  font-weight: bold;\n  display: block;\n  padding-bottom: 1em;\n  cursor: pointer;\n}\n\n/* iOS Safari does not fire tap/click events on <a> elements that lack an\n   href attribute unless they are styled with cursor: pointer. The accordion\n   triggers in StandardReports/StartPage use <a onClick> without href, so\n   ensure they are recognized as interactive on iOS. */\n.card-header a {\n  cursor: pointer;\n}\n\n/* CustomReports uses <a href=\"\" onClick> with font-weight-bold for Select all/Clear all\n   links. Empty href doesn't satisfy iOS tap heuristic, so ensure these are recognized\n   as interactive. */\na.font-weight-bold {\n  cursor: pointer;\n}\n\n.dataButton a, .dataButton, a.dataButton:visited {\n  filter: none !important;\n  background: #122366;\n  color: #fff;\n  margin-top: 5px;\n  text-shadow: none;\n}\n\n  .dataButton a, .dataButton:hover:not([disabled]) {\n    color: #122366;\n    background: #eee;\n  }\n\n  .dataButton a, .dataButton:disabled {\n    background: #dddddd;\n  }\n\na.dataButton {\n  padding: 8px;\n  text-decoration: none;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\ntextarea.form-control {\n  height: 125px;\n}\n\n.fortypct {\n  width: 40% !important;\n  display: inline-block;\n}\n/*--------------------------------------------------------*/\n\n\n/*\n------------------------------------------------------------\n|  Data table styles that should be replaced with existing styles\n------------------------------------------------------------\n*/\n.header {\n  background-color: #122366;\n  color: #fff;\n  font-weight: bold;\n  border: 1px solid #91a4f1;\n}\n\n.dwGridRow {\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #91a4f1;\n}\n\n.dwGridRowGray {\n  background-color: lightgray;\n  color: #000;\n  border: 1px solid #91a4f1;\n  font-weight: bold;\n}\n\n.bold {\n  color: #000;\n  font-weight: bold;\n}\n/*--------------------------------------------------------*/\n\n\n/*\n------------------------------------------------------------\n|  CSS Grid styles\n------------------------------------------------------------\n*/\n.cell2_1 {\n  grid-column: 1 !important;\n  grid-row: 2 !important;\n}\n\n.cell2_2 {\n  grid-column: 2 !important;\n  grid-row: 2 !important;\n}\n\n.vendorsReportedGrid {\n  display: grid;\n  grid-template-columns: 20% 20% 20% 20% 20%;\n  grid-template-rows: auto auto auto auto auto;\n  width: 100%;\n}\n\n.vendorsReportedGrid2col {\n  display: grid;\n  grid-template-columns: 35% 60%;\n  grid-template-rows: auto auto;\n  width: 100%;\n}\n\n.vendorsReportedGrid3col {\n  display: grid;\n  grid-template-columns: 35% 40% 20%;\n  grid-template-rows: auto auto;\n  width: 100%;\n}\n\n.vendorsReportedGrid6Col {\n  display: grid;\n  grid-template-columns: 16% 16% 16% 16% 16% 16%;\n  grid-template-rows: auto auto auto auto auto;\n  width: 100%;\n}\n\n.vendorsReportedGrid7Col {\n  display: grid;\n  grid-template-columns: 14% 14% 14% 14% 14% 14%;\n  grid-template-rows: auto auto auto auto auto;\n  width: 100%;\n}\n\n.vendorsReportedGrid8Col {\n  display: grid;\n  grid-template-columns: 12% 12% 12% 12% 12% 12%;\n  grid-template-rows: auto auto auto auto auto;\n  width: 100%;\n}\n\n  .vendorsReportedGrid2col DIV, .vendorsReportedGrid DIV, .vendorsReportedGrid6Col DIV, .vendorsReportedGrid7Col DIV, .vendorsReportedGrid8Col DIV {\n    padding: 10px;\n    font-family: Arial;\n  }\n\n.newRow {\n  grid-column-start: 1;\n}\n\n.col1 {\n  grid-column: 1 !important;\n}\n\n.col2 {\n  grid-column: 2 !important;\n}\n\n.col3 {\n  grid-column: 3 !important;\n}\n\n.col4 {\n  grid-column: 4 !important;\n}\n\n.col5 {\n  grid-column: 5 !important;\n}\n\n.row2 {\n  grid-row: 2 !important;\n}\n\n.row3 {\n  grid-row: 3 !important;\n}\n\n.row4 {\n  grid-row: 4 !important;\n}\n\n.row5 {\n  grid-row: 5 !important;\n}\n\n.row6 {\n  grid-row: 6 !important;\n}\n/*--------------------------------------------------------*/\n\n\n.rotated {\n  writing-mode: tb-rl;\n  transform: rotate(-180deg);\n}\n\n.center {\n  text-align: center;\n}\n\n/*\n------------------------------------------------------------\n|  table styles\n------------------------------------------------------------\n*/\n.grid-container {\n  display: grid;\n  grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;\n  grid-template-rows: auto auto auto auto auto auto;\n}\n\n.grid-container-Fuel {\n  display: grid;\n  grid-template-columns: 3% 12% 12% 12% 12% 12% 12% 12%;\n  grid-template-rows: auto auto auto auto auto auto auto auto auto;\n}\n\n.grid-container-Fuel2 {\n  display: grid;\n  grid-template-columns: 3% 12% 8% 8% 8% 8% 8% 8% 8% 8% 8% 8%;\n  grid-template-rows: auto auto auto auto auto auto auto auto auto;\n}\n\n  .grid-container-Fuel div, .grid-container-Fuel2 div {\n    padding: 5px;\n    font-family: Arial;\n    /*font-size: 0.9rem !important;*/\n  }\n\n\n.grid-item {\n  padding: 10px;\n  text-align: center;\n  font-family: Arial;\n  font-size: 14px;\n}\n\n.rowboundary1_3 {\n  grid-row-start: 1 !important;\n  grid-row-end: 3 !important;\n}\n\n.rowboundary1_2 {\n  grid-row-start: 1 !important;\n  grid-row-end: 2 !important;\n}\n\n.rowboundary2_3 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n}\n\n.rowboundary3_4 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n}\n\n.rowboundary3_6 {\n  grid-row-start: 3 !important;\n  grid-row-end: 6 !important;\n}\n\n.rowboundary4_5 {\n  grid-row-start: 4 !important;\n  grid-row-end: 5 !important;\n}\n\n.rowboundary4_7 {\n  grid-row-start: 4 !important;\n  grid-row-end: 7 !important;\n}\n\n.rowboundary5_6 {\n  grid-row-start: 5 !important;\n  grid-row-end: 6 !important;\n}\n\n.rowboundary6_7 {\n  grid-row-start: 6 !important;\n  grid-row-end: 7 !important;\n}\n\n.colboundary3_8 {\n  grid-column-start: 3 !important;\n  grid-column-end: 8 !important;\n}\n\n.colboundary3_13 {\n  grid-column-start: 3 !important;\n  grid-column-end: 13 !important;\n}\n\n.colboundary1_2 {\n  grid-column-start: 1 !important;\n  grid-column-end: 2 !important;\n}\n\n.colboundary1_5 {\n  grid-column-start: 1 !important;\n  grid-column-end: 5 !important;\n}\n\n.colboundary2_3 {\n  grid-column-start: 2 !important;\n  grid-column-end: 3 !important;\n}\n\n.colboundary3_4 {\n  grid-column-start: 3 !important;\n  grid-column-end: 4 !important;\n}\n\n.colboundary4_5 {\n  grid-column-start: 4 !important;\n  grid-column-end: 5 !important;\n}\n\n\n.colboundary3_5 {\n  grid-column-start: 3 !important;\n  grid-column-end: 5 !important;\n}\n\n.colboundary3_7 {\n  grid-column-start: 3 !important;\n  grid-column-end: 7 !important;\n}\n\n.colboundary3_9 {\n  grid-column-start: 3 !important;\n  grid-column-end: 9 !important;\n}\n\n.colboundary5_7 {\n  grid-column-start: 5 !important;\n  grid-column-end: 7 !important;\n}\n\n.colboundary5_6 {\n  grid-column-start: 5 !important;\n  grid-column-end: 6 !important;\n}\n\n.colboundary6_7 {\n  grid-column-start: 6 !important;\n  grid-column-end: 7 !important;\n}\n\n.colboundary7_9 {\n  grid-column-start: 7 !important;\n  grid-column-end: 9 !important;\n}\n\n.colboundary7_8 {\n  grid-column-start: 7 !important;\n  grid-column-end: 8 !important;\n}\n\n.colboundary8_9 {\n  grid-column-start: 8 !important;\n  grid-column-end: 9 !important;\n}\n\n.colboundary9_10 {\n  grid-column-start: 9 !important;\n  grid-column-end: 10 !important;\n}\n\n.colboundary9_11 {\n  grid-column-start: 9 !important;\n  grid-column-end: 11 !important;\n}\n\n.colboundary10_11 {\n  grid-column-start: 10 !important;\n  grid-column-end: 11 !important;\n}\n\n.colboundary11_12 {\n  grid-column-start: 11 !important;\n  grid-column-end: 12 !important;\n}\n\n.colboundary11_13 {\n  grid-column-start: 11 !important;\n  grid-column-end: 13 !important;\n}\n\n.colboundary12_13 {\n  grid-column-start: 12 !important;\n  grid-column-end: 13 !important;\n}\n\n.item1 {\n  grid-row-start: 1 !important;\n  grid-row-end: 3 !important;\n}\n\n.item2 {\n  grid-column-start: 2 !important;\n  grid-column-end: 4 !important;\n}\n\n.item3 {\n  grid-column-start: 4 !important;\n  grid-column-end: 6 !important;\n}\n\n.item4 {\n  grid-column-start: 6 !important;\n  grid-column-end: 8 !important;\n}\n\n.item5 {\n  grid-column-start: 8 !important;\n  grid-column-end: 10 !important;\n}\n\n.item6 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 2 !important;\n  grid-column-end: 3 !important;\n}\n\n.item7 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 3 !important;\n  grid-column-end: 4 !important;\n}\n\n.item8 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 4 !important;\n  grid-column-end: 5 !important;\n}\n\n.item9 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 5 !important;\n  grid-column-end: 6 !important;\n}\n\n.item10 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 6 !important;\n  grid-column-end: 7 !important;\n}\n\n.item11 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 7 !important;\n  grid-column-end: 8 !important;\n}\n\n.item12 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 8 !important;\n  grid-column-end: 9 !important;\n}\n\n.item13 {\n  grid-row-start: 2 !important;\n  grid-row-end: 3 !important;\n  grid-column-start: 9 !important;\n  grid-column-end: 10 !important;\n}\n\n.item14 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 1 !important;\n  grid-column-end: 2 !important;\n}\n\n.item15 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 2 !important;\n  grid-column-end: 3 !important;\n}\n\n.item16 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 3 !important;\n  grid-column-end: 4 !important;\n}\n\n.item17 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 4 !important;\n  grid-column-end: 5 !important;\n}\n\n.item18 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 5 !important;\n  grid-column-end: 6 !important;\n}\n\n.item19 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 6 !important;\n  grid-column-end: 7 !important;\n}\n\n.item20 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 7 !important;\n  grid-column-end: 8 !important;\n}\n\n.item21 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 8 !important;\n  grid-column-end: 9 !important;\n}\n\n.item22 {\n  grid-row-start: 3 !important;\n  grid-row-end: 4 !important;\n  grid-column-start: 9 !important;\n  grid-column-end: 10 !important;\n}\n\n.item23 {\n  grid-column-start: 2 !important;\n  grid-column-end: 9 !important;\n  margin-left: 8.5%;\n  margin-right: 8.5%;\n  grid-row-start: 4 !important;\n  grid-row-end: 5 !important;\n  /*height:400px;*/\n}\n\n.lev2-grid-container {\n  display: grid;\n  grid-template-columns: 32% 36% 32%;\n  grid-template-rows: auto;\n}\n\n.lev3-grid-container {\n  display: grid;\n  grid-template-columns: 10% 80% 10%;\n  grid-template-rows: auto;\n}\n\n.lev4-grid-container {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  grid-template-rows: auto;\n}\n\n.orange-block {\n  background-color: orange;\n  margin-top: 20px;\n}\n\n.orange-block-header {\n  padding: 5px;\n  /*height: 100px;*/\n}\n\n.left-arrow {\n  border-left: 2px solid #91a4f1;\n  border-bottom: 2px solid #91a4f1;\n  height: 75px;\n}\n\n.right-arrow {\n  border-right: 2px solid orange;\n  border-bottom: 2px solid orange;\n  height: 75px;\n}\n\n.white-border {\n  border: 1px solid #fff;\n  text-align: center;\n}\n\n.blue-background {\n  background-color: #bdd6ee;\n}\n\n.orange-background {\n  background-color: #f4b083;\n}\n\n.yellow-background {\n  background-color: #ffe599;\n}\n\n.gray-background {\n  background-color: gray !important;\n}\n\n.green-background {\n  background-color: #c6efce;\n  color: #006100;\n}\n\n.red-background {\n  background-color: #ffc7ce;\n  color: #9c0006;\n}\n\n.greentext {\n  color: darkgreen;\n  font-weight: bold;\n}\n\n.redtext {\n  color: darkred;\n  font-weight: bold;\n}\n\n.marginTop15 {\n  margin-top: 15px;\n}\n\nul.legendList li.blueBullet::before {\n  color: #bdd6ee;\n}\n\nul.legendList li.orangeBullet::before {\n  color: #f4b083;\n}\n\nul.legendList li.yellowBullet::before {\n  color: #ffe599;\n}\n\nul.legendList li.greenBullet::before {\n  color: #c6efce;\n}\n\nul.legendList li.redBullet::before {\n  color: #ffc7ce;\n}\n\ndiv.legendDiv {\n  float: right;\n  width: 60%;\n}\n\nul.legendList {\n  font-size: 0.75em;\n  list-style: none;\n  margin-top: 10px;\n}\n\n  ul.legendList li {\n    margin-top: -5px;\n  }\n\n    ul.legendList li::before {\n      content: \"\\25C6\"; /* Add content: \\2022 is the CSS Code/unicode for a bullet */\n      font-weight: bold; /* If you want it to be bold */\n      display: inline-block; /* Needed to add space between the bullet and the text */\n      width: 1em; /* Also needed for space (tweak if needed) */\n      margin-left: -1em; /* Also needed for space (tweak if needed) */\n      font-size: 1.5em;\n    }\n\n.lowercaseList {\n  list-style-type: lower-alpha;\n}\n\ninput:invalid {\n  border: 2px dashed red;\n  background-color: pink;\n}\n\ninput.form-control {\n  display: inline-block;\n  width: 80%;\n}\n\n.requiredDash {\n  color: red;\n  padding-right: 5px;\n}\n\nul.requiredDashList {\n  font-size: 0.75em;\n  list-style: none;\n  margin-top: 10px;\n  margin-bottom: -15px;\n}\n\n  ul.requiredDashList li {\n    margin-top: -5px;\n  }\n\n    ul.requiredDashList li::before {\n      color: red;\n      content: \"\\002A\"; /* Add content: \\002A is the CSS Code/unicode for asterisk */\n      font-weight: bold; /* If you want it to be bold */\n      display: inline-block; /* Needed to add space between the bullet and the text */\n      width: 1em; /* Also needed for space (tweak if needed) */\n      margin-left: -1em; /* Also needed for space (tweak if needed) */\n      font-size: 1.5em;\n    }\n\n\n\n.react-tabs__tab-list {\n  margin-bottom: 0 !important;\n}\n\n.react-tabs__tab-panel--selected {\n  background-color: #fff;\n  padding: 10px;\n  border: 1px solid #aaa;\n  border-top: none;\n}\n\n.react-tabs__tab {\n  border-color: #aaa !important;\n  color: black !important;\n  border-radius: 5px 5px 0 0 !important;\n}\n\n\n\n.pseudo-accordion {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.takeaways {\n  border: #000 solid 3px;\n  padding: 1.5%;\n}\n\n/*------------------------------------------------------------------------\n    Guided search breadcrums\n--------------------------------------------------------------------------\n*/\n.steps {\n  /*padding-left: 1%;*/\n  padding-left: 0px;\n  margin: 14px 0 24px 0;\n  height: 32px;\n  white-space: nowrap;\n  font-weight: bold;\n}\n\n  .steps .active {\n    background-image: url(\"/data_warehouse/images/step_a.png\");\n  }\n\n  .steps .step span {\n    display: inline-block;\n    padding-left: 5px;\n    padding-right: 7px;\n    color: #324f6e;\n    background-color: #ffe0a6;\n    font-size: 121%;\n    font-style: italic;\n  }\n\n  .steps .step {\n    display: inline-block;\n    background: url(\"/data_warehouse/images/step_a.png\") no-repeat top right;\n    padding: 3px 17px 0 3px;\n    margin-right: 5px;\n    height: 34px;\n    color: #fff;\n    shadow: 5px 5px 4px #888888;\n    float: left;\n  }\n\n  .steps .completed {\n    background-image: url(\"/data_warehouse/images/step_c.png\");\n    padding: 3px 17px 0 3px;\n    color: rgb(58, 110, 162);\n    color: #f1f1f1;\n    cursor: pointer;\n  }\n\n  .steps .gray, .steps .laststepgray {\n    background-image: url(\"/data_warehouse/images/step_g.png\");\n    color: #f1f1f1;\n    cursor: default;\n  }\n\n  .steps .laststepgray {\n    background-image: url(\"/data_warehouse/images/step_g_last.png\");\n  }\n\n\n/*------------------------------------------------------------------\n| Benefit matrix styles\n--------------------------------------------------------------------*/\n.benefitMatrix p, .benefitMatrix b, .benefitMatrix span, .benefitMatrix li {\n  font-size: x-large;\n}\n\n.benefitMatrix button, .benefitMatrix th, .benefitMatrix td, .benefitMatrix .grid-container-Fuel, .benefitMatrix .grid-container-Fuel2, .benefitMatrix .vendorsReportedGrid, .benefitMatrix .vendorsReportedGrid2col, .benefitMatrix .vendorsReportedGrid3col, .benefitMatrix .vendorsReportedGrid6Col, .benefitMatrix .vendorsReportedGrid7Col, .benefitMatrix .vendorsReportedGrid8Col, .benefitMatrix .vendorsReportedGrid span, .benefitMatrix .vendorsReportedGrid2col span, .benefitMatrix .vendorsReportedGrid3col span, .benefitMatrix .vendorsReportedGrid6Col span, .benefitMatrix .vendorsReportedGrid7Col span, .benefitMatrix .vendorsReportedGrid8Col span, .container .col-sm-2 {\n  font-size: 20px !important;\n}\n/*------------------------------------------------------------------*/\n@media print {\n  .page-footer, .sidebar-content, .noPrint {\n    display: none;\n  }\n}\n/*--------------------------------------------------------*/\n/* Fix for Material-UI slider labels with webpack 5 */\n.MuiSlider-marked .MuiSlider-markLabel {\n  transform: translateX(-65%) rotate(-45deg) !important;\n  transform-origin: center top !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
